import React, { Component } from 'react'
import Modal from 'react-modal'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import OnboardingEventConfigPageUI from './OnboardingEventConfigPageUI'

class OnboardingEventConfigPageSF extends Component {
    constructor(props) {
        super(props)
        this.state = {
            eventList: null,
            loading: true,
            errorList: null
        }
    }

    componentDidMount() {
        this.getEventConfigurations()
        Modal.setAppElement('body')
    }

    getEventConfigurations = () => {
        let context = this.props.context
        // Using RestApiUtils directly for now as CacheManager might need specific setup
        RestApiUtils.get(context, '/api/notify-event-configurations', this.getEventConfigurationsCallback)
    }

    getEventConfigurationsCallback = (response) => {
        if (Array.isArray(response.entities)) {
            this.setState({ eventList: response.entities, loading: false })
        } else if (response.errorList) {
            this.setState({ errorList: response.errorList, loading: false })
        } else {
            // Handle unexpected response
            this.setState({ eventList: [], loading: false })
        }
    }

    handleDeleteEvent = (eventCode) => {
        if (window.confirm('Are you sure you want to delete this event?')) {
            // this.setState({ loading: true })
            let context = this.props.context
            RestApiUtils.delete(context, `/api/notify-event-configurations/${eventCode}`, this.handleDeleteEventCallback)
            setTimeout(() => {
                this.setState({ loading: false })
                this.getEventConfigurations()
            }, 1500);
        }
    }

    handleDeleteEventCallback = (response) => {
        if (response && response.errorList && response.errorList.length > 0) {
            this.setState({ loading: false, errorList: response.errorList })
        } else {
            this.setState({ loading: false, errorList: null }) // Optional: clear errors/ensure loading before fetch
            this.getEventConfigurations()
        }
    }

    render() {
        return (
            <OnboardingEventConfigPageUI
                context={this.props.context}
                eventList={this.state.eventList}
                loading={this.state.loading}
                errorList={this.state.errorList}
                onRefreshClick={() => { this.getEventConfigurations() }}
                onDeleteClick={this.handleDeleteEvent}
            />
        )
    }
}

export default OnboardingEventConfigPageSF
